module.exports = __webpack_public_path__ + "static/media/education-object-3-0-0.523d7027.png";